module.exports = __webpack_public_path__ + "static/banner-kendra-desktop-9d79f9b8e5bcd1668f6b36cf87384c23.jpg";